import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var localReferenceDetailsConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  calloutProps: {
    state: 'lilac',
    description: 'As per DOT rules, share a local reference if your permanent address is in a different city.',
    iconName: 'InfoIcon'
  },
  stepDetailsProps: {
    title: 'STEP 10',
    heading: 'Local reference details',
    avatarIcon: 'ReferenceIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    mobileNumber: {
      label: 'Local reference mobile number',
      hintText: 'This number will be verified via OTP',
      inputRegex: '^[6-9]{1}[0-9]*$',
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter local reference mobile number',
      validationRegex: '^[6-9]{1}[0-9]{9}$',
      maxLength: 10,
      id: 'mobileNumber',
      isRequired: true
    },
    name: {
      label: 'Full name of local referee',
      isDisabled: false,
      placeholder: 'Enter full name of local referee',
      keyboardType: 'default',
      maxLength: 40,
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'name',
      isRequired: true
    },
    houseNo: {
      label: 'House/flat no',
      isDisabled: false,
      placeholder: 'Enter house/flat no',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s/-]*$',
      validationRegex: '^[a-zA-Z0-9\\s/-]{1,50}$',
      id: 'houseNo',
      isRequired: true
    },
    street: {
      label: 'Street/road name',
      isDisabled: false,
      placeholder: 'Enter street/road name',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'street',
      isRequired: true
    },
    area: {
      label: 'Area/sector/locality',
      isDisabled: false,
      placeholder: 'Enter area/sector',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'area',
      isRequired: true
    },
    landmark: {
      label: 'Landmark (optional)',
      isDisabled: false,
      placeholder: 'Enter landmark',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'landmark',
      isRequired: false
    },
    pinCode: {
      label: 'PIN code',
      isDisabled: false,
      placeholder: 'Enter PIN code',
      keyboardType: 'phone-pad',
      inputRegex: '^[0-9]*$',
      validationRegex: '^[1-9][0-9]{5}$',
      maxLength: 6,
      id: 'pinCode',
      isRequired: true
    },
    city: {
      label: 'Village/town/city',
      isDisabled: false,
      placeholder: 'Enter village/town',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'city',
      isRequired: true
    },
    district: {
      label: 'District',
      isDisabled: true,
      placeholder: 'Enter district',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'district',
      isRequired: true
    },
    state: {
      label: 'State/UT',
      isDisabled: true,
      placeholder: 'Enter state/UT',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'state',
      isRequired: true
    }
  },
  submitButtonProps: {
    leftCta: {
      version: 'variable-width',
      title: 'Verify via OTP',
      size: 'md'
    }
  }
};
export var currentAddressDetailsConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: true,
  calloutProps: {
    state: 'lilac',
    description: 'As per DOT rules, share your current address if it differs from your permanent address.',
    iconName: 'InfoIcon'
  },
  stepDetailsProps: {
    title: 'STEP 9',
    heading: 'Current address details',
    avatarIcon: 'LocationIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    houseNo: {
      label: 'House/flat no',
      isDisabled: false,
      placeholder: 'Enter house/flat no',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s/-]*$',
      validationRegex: '^[a-zA-Z0-9\\s/-]{1,50}$',
      id: 'houseNo',
      isRequired: true
    },
    street: {
      label: 'Street/road name',
      isDisabled: false,
      placeholder: 'Enter street/road name',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'street',
      isRequired: true
    },
    area: {
      label: 'Area/sector/locality',
      isDisabled: false,
      placeholder: 'Enter area/sector',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'area',
      isRequired: true
    },
    landmark: {
      label: 'Landmark (optional)',
      isDisabled: false,
      placeholder: 'Enter landmark',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z0-9\\s]*$',
      validationRegex: '^[a-zA-Z0-9\\s]{3,50}$',
      id: 'landmark',
      isRequired: false
    },
    pinCode: {
      label: 'PIN code',
      isDisabled: false,
      placeholder: 'Enter PIN code',
      keyboardType: 'phone-pad',
      inputRegex: '^[0-9]*$',
      validationRegex: '^[1-9][0-9]{5}$',
      maxLength: 6,
      id: 'pinCode',
      isRequired: true
    },
    city: {
      label: 'Village/town/city',
      isDisabled: false,
      placeholder: 'Enter village/town',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'city',
      isRequired: true
    },
    district: {
      label: 'District',
      isDisabled: true,
      placeholder: 'Enter district',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'district',
      isRequired: true
    },
    state: {
      label: 'State/UT',
      isDisabled: true,
      placeholder: 'Enter state/UT',
      keyboardType: 'default',
      inputRegex: '^[a-zA-Z\\s]*$',
      validationRegex: '^[a-zA-Z\\s]{3,50}$',
      id: 'state',
      isRequired: true
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};